export default __webpack_public_path__ + "static/fb-765e18e8e6b6f3da6ca0b8b6e0e9cd68.svg";